import React, { useEffect, useState } from 'react';
import { idleTimeoutManager } from '../services/IdleTimeoutManager';

export const IdleWarningToast: React.FC = () => {
  const [warningActive, setWarningActive] = useState(false);
  const [remainingSeconds, setRemainingSeconds] = useState(30);

  useEffect(() => {
    const handleWarning = (data: { remainingSeconds: number }) => {
      setWarningActive(true);
      setRemainingSeconds(data.remainingSeconds);
    };

    const handleRestored = () => {
      setWarningActive(false);
    };

    idleTimeoutManager.on('idle:warning', handleWarning);
    idleTimeoutManager.on('idle:activityRestored', handleRestored);
    idleTimeoutManager.on('idle:lock', handleRestored);

    return () => {
      idleTimeoutManager.off('idle:warning', handleWarning);
      idleTimeoutManager.off('idle:activityRestored', handleRestored);
      idleTimeoutManager.off('idle:lock', handleRestored);
    };
  }, []);

  useEffect(() => {
    if (!warningActive) return;
    const interval = setInterval(() => {
      setRemainingSeconds((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [warningActive]);

  if (!warningActive) return null;

  return (
    <div className="fixed top-14 left-1/2 -translate-x-1/2 z-50 flex items-center space-x-3 rounded-2xl border border-amber-500/50 bg-bg-surface/95 px-4 py-2.5 shadow-2xl backdrop-blur-xl animate-fade-in text-text-primary">
      <div className="flex h-7 w-7 items-center justify-center rounded-full bg-amber-500/20 text-amber-400 font-mono text-xs font-bold animate-pulse">
        {remainingSeconds}s
      </div>

      <div className="text-xs">
        <p className="font-bold text-text-primary">Inactivity Warning</p>
        <p className="text-[11px] text-text-muted font-mono">Locking session in {remainingSeconds} seconds...</p>
      </div>

      <button
        type="button"
        onClick={() => idleTimeoutManager.resetActivity()}
        className="rounded-lg bg-accent-primary text-bg-primary px-3 py-1 text-xs font-mono font-bold hover:opacity-90 transition shadow-sm"
      >
        Stay Active
      </button>
    </div>
  );
};
